import { render, staticRenderFns } from "./Sign-Up.vue?vue&type=template&id=9fd9f076&"
import script from "./Sign-Up.vue?vue&type=script&lang=js&"
export * from "./Sign-Up.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports